"use client"

import { useState } from "react"

import { GameItem, SituationSetupData } from "@/app/types"
import { useNavigationStore } from "@/store/navigation"
import { GameGrid } from "@/components/GameGrid"
import GameSetupModal from "@/components/ui/GameSetupModal"


const EMPTY_SETUP: SituationSetupData = {
  title: "",
  instructions: "",
  subject: "ภาษาไทย",
  topic: "ห น้ำ",
  grade: "ป1",
  backgroundImage: null,
}

export default function GameLibrary() {
  const { setActivePage } = useNavigationStore()
  const [situationSetup, setSituationSetup] = useState<SituationSetupData | null>(null)
  const [situationDraft, setSituationDraft] = useState<SituationSetupData>(EMPTY_SETUP)
  const [selectedFileName, setSelectedFileName] = useState("")
  const [isSituationModalOpen, setIsSituationModalOpen] = useState(false)
  const [selectedGameKind, setSelectedGameKind] = useState<string>("")

  const handleSelectGame = (item: GameItem) => {
    if (item.kind === "situation" || item.kind === "quiz") {
      setSelectedGameKind(item.kind)
      setSituationDraft(situationSetup ?? EMPTY_SETUP)
      setSelectedFileName("")
      setIsSituationModalOpen(true)
      return
    }

    if (item.href) {
      setActivePage(item.href)
    }
  }

  const handleConfirmSituation = () => {
    const payload: SituationSetupData = {
      title: situationDraft.title.trim(),
      instructions: situationDraft.instructions.trim(),
      subject: situationDraft.subject,
      topic: situationDraft.topic,
      grade: situationDraft.grade,
      backgroundImage: situationDraft.backgroundImage,
    }

    setSituationSetup(payload)

    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("situation-setup", JSON.stringify(payload))
    }

    setIsSituationModalOpen(false)
    if (selectedGameKind === "quiz") {
      setActivePage("/create-game/quiz")
    } else {
      setActivePage("/create-game/situation")
    }
  }

  return (
    <div className="flex h-full w-full flex-col items-center rounded-2xl bg-white px-6 py-9 sm:items-start">
      <div className="mb-6 flex items-end"></div>
      <div className="h-full w-full">
        <GameGrid onSelectGame={handleSelectGame} />
      </div>



      <GameSetupModal
        open={isSituationModalOpen}
        titleLabel={selectedGameKind === "quiz" ? "Game show Quiz" : "Situation"}
        value={situationDraft}
        fileName={selectedFileName}
        onFileNameChange={setSelectedFileName}
        onChange={setSituationDraft}
        onCancel={() => setIsSituationModalOpen(false)}
        onConfirm={handleConfirmSituation}
      />
    </div>
  )
}
